import React from 'react';
import { connect } from 'react-redux';
import LeaseForm from 'components/LeaseForm';
import { createLease } from 'actions/leases';
import { getSubmitStatus } from 'reducers';

let NewLease = ({ createLease, ...props }) => {
  const { SubNav } = props;
  if (!props.sub || !props.user) {
    return <div>Loading</div>;
  }

  return (
    <div>
      <h1>New Lease</h1>
      <br />
      <SubNav />
      <LeaseForm
        initialValues={props.initialValues}
        onSubmit={(values) => createLease(values)}
        {...props}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  saveStatus: getSubmitStatus(state, 'lease'),
});

const mapDispatchToProps = {
  createLease,
};

NewLease = connect(mapStateToProps, mapDispatchToProps)(NewLease);

export default NewLease;
